<script setup lang="ts">
import { computed, watch } from "vue";

import LoadingSpinner from "~/components/dumb/LoadingSpinner.vue";
import PageIcon from "~/components/dumb/PageIcon.vue";
import TaskOrDocOrSkillPreviewTooltip from "~/components/dumb/TaskOrDocOrSkillPreviewTooltip.vue";
import { Placement } from "~/shared/enums";
import { useAppStore } from "~/stores";
import { getDocLink } from "~/utils/common";
import { useAsyncDoc } from "~/utils/entityIncrementalLoading";

const props = defineProps<{
  duid: string;
}>();

const emit = defineEmits<{
  contextMenu: [MouseEvent];
}>();

const appStore = useAppStore();

const { doc, isLoading } = useAsyncDoc(computed(() => props.duid));

watch([doc, isLoading, () => doc.value?.inTrash], ([value, loading, inTrash]) => {
  if ((!value || inTrash) && !loading) {
    appStore.removeRecentDoc(props.duid);
  }
});
</script>

<template>
  <TaskOrDocOrSkillPreviewTooltip
    v-if="!isLoading && doc && !doc.inTrash"
    :doc-duid="doc.duid"
    block
    height-block
    :skidding="0"
    :placement="Placement.RIGHT">
    <RouterLink
      class="flex h-9 w-full cursor-pointer items-center gap-3 truncate rounded px-3 bg-std hover:bg-md"
      :to="getDocLink(doc)"
      @contextmenu="emit('contextMenu', $event)">
      <span class="grow select-none truncate text-sm font-medium text-md">
        {{ doc.title }}
      </span>

      <PageIcon :page="doc" class="icon-md" />
    </RouterLink>
  </TaskOrDocOrSkillPreviewTooltip>
  <div v-else-if="isLoading" class="flex h-9 w-full cursor-default items-center gap-3 truncate rounded px-3 bg-std">
    <LoadingSpinner small />
  </div>
</template>
